module.exports = __webpack_public_path__ + "static/html-element-advanced_8-0833bd1404dfa55d94491ff805069170.jpg";